import { render, staticRenderFns } from "./OutfitsVitrina.vue?vue&type=template&id=d9d6c498&"
import script from "./OutfitsVitrina.vue?vue&type=script&lang=js&"
export * from "./OutfitsVitrina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports